import React from 'react';
import PropTypes from 'prop-types';

import DocumentListItem from '@molecules/DocumentListItem';
import { BodyLarge, DividerLightGreyStyled, DivWithShadowAlternate, H4 } from '@styled';

const TrusteeEventDocuments = ({ documents }) => {
    return (
        <div>
            <H4 className="mb-1.5rem">Related Documents</H4>
            <DivWithShadowAlternate className="p-2rem">
                <BodyLarge className="mb-2rem">Familiarize with important details in advance</BodyLarge>

                {documents.length === 0 ? (
                    <>
                        <DividerLightGreyStyled className="mb-2rem" />
                        <H4>Looks like there are no documents available. Check back closer to the event.</H4>
                    </>
                ) : (
                    documents.map((document, index) => <DocumentListItem document={document} key={index} />)
                )}
            </DivWithShadowAlternate>
        </div>
    );
};

TrusteeEventDocuments.propTypes = {
    documents: PropTypes.arrayOf(
        PropTypes.shape({
            document_title: PropTypes.string.isRequired,
            document_description: PropTypes.string,
            document_file: PropTypes.string,
            document_url: PropTypes.string,
        })
    ).isRequired,
};

export default TrusteeEventDocuments;
